<template>
    <div class="title-block">
        <div class="title-block__title">
            Добавить роль
        </div>
    </div>
    <form class="form-narrow mb-4">
        <label class="form-label" for="role">Введите название роли</label>
        <input type="text" class="form-control" name="role" id="role">
    </form>
    <div class="table-responsive">
        <div class="form-label">Установите формы доступа</div>
        <table class="access-add-role-table  table">
            <thead>
                <tr>
                    <th>
                        Название раздела
                    </th>
                    <th>
                        Просмотр
                    </th>
                    <th>
                        Редактирование
                    </th>
                    <th>
                        Удаление
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in accessList">
                    <td>
                        {{ item[0] }}
                    </td>
                    <td>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" :id="item[1][0]" v-model="item[1][1]">
                        </div>
                    </td>
                    <td>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" :id="item[2][0]" v-model="item[2][1]">
                        </div>
                    </td>
                    <td>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" :id="item[3][0]" v-model="item[3][1]">
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="form-narrow">
        <div class="d-flex align-items-stretch py-3">
            <button type="button" class="btn btn-lg btn-primary flex-grow-1 me-3">
                Сохранить
            </button>
            <a href="/access-group-list" type="button" class="btn btn-lg btn-outline-dark flex-grow-1">
                Отменить
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "AccessAddRole",
    data: () => {
        return {
            accessList: [
                [
                    'Документация',
                    ['docView', true],
                    ['docEdit', false],
                    ['docDelete', false],
                ],
                [
                    'Письма и рассылки',
                    ['lettersView', true],
                    ['lettersEdit', true],
                    ['lettersDelete', false],
                ],
                [
                    'Документооборот',
                    ['edoView', false],
                    ['edoEdit', false],
                    ['edoDelete', false],
                ],
                [
                    'Банк данных',
                    ['baseView', false],
                    ['baseEdit', false],
                    ['baseDelete', false],
                ],
                [
                    'Группы устройств',
                    ['groupsView', true],
                    ['groupsEdit', true],
                    ['groupsDelete', true],
                ],
                [
                    'Контент',
                    ['contentView', true],
                    ['contentEdit', true],
                    ['contentDelete', true],
                ],
                [
                    'Плейлисты',
                    ['playlistsView', true],
                    ['playlistsEdit', true],
                    ['playlistsDelete', true],
                ],
                [
                    'Отчеты',
                    ['reportsView', true],
                    ['reportsEdit', true],
                    ['reportsDelete', true],
                ],
                [
                    'Логи',
                    ['logsView', false],
                    ['logsEdit', false],
                    ['logsDelete', false],
                ],
                [
                    'Уведомления',
                    ['notificationsView', true],
                    ['notificationsEdit', true],
                    ['notificationsDelete', true],
                ],
                [
                    'Настройки доступа',
                    ['accessView', false],
                    ['accessEdit', false],
                    ['accessDelete', false],
                ],
            ]
        };
    },
};
</script>
